var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-card',{staticClass:"col"},[_c('admin-vip-group-create-form',{attrs:{"vip-group":_vm.group,"is-loading":_vm.isLoading},on:{"submit":_vm.onSubmit}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }